import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import Quasar from 'quasar/src/vue-plugin.js';
import quasarUserOptions from './quasar-user-options'   
import '../src/assets/main.scss'
import Masonry from 'masonry-layout'
import imagesLoaded from 'imagesloaded'

createApp(App).use(Quasar).use(router).mount('#app')
